import BoletoReceberService from "@/services/BoletoReceberService";

export const boletoReceber = {
  namespaced: true,
  state: {
    boletoReceber: {},
  },
  actions: {
    getBoletoReceber({ commit }, payload) {
      return BoletoReceberService.GetBoletoReceber(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
    getBoletoReceberOData({ commit }, payload) {
      return BoletoReceberService.GetBoletoReceberOData(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error)
      );
    },
    postMovimentacaoApi({ commit }, payload) {
      return BoletoReceberService.PostMovimentacaoApi(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
    postPreviaRetornoCnab({ commit }, payload) {
      return BoletoReceberService.PostPreviaRetornoCnab(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
    postConfirmarRetornoCnab({ commit }, payload) {
      return BoletoReceberService.PostConfirmarRetornoCnab(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
    postGerarRemessa({ commit }, payload) {
      return BoletoReceberService.PostGerarRemessa(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
    getBoletoRemessaOData({ commit }, payload) {
      return BoletoReceberService.GetBoletoRemessaOData(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error)
      );
    },
    downloadRemessaArquivo({ commit }, payload) {
      return BoletoReceberService.DownloadRemessaArquivo(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
  },
  mutations: {},
};

export default boletoReceber;
